import { useEffect, type ReactNode } from "react";
import { useUIStore } from "../../stores/ui";

export function ThemeProvider({ children }: { children: ReactNode }) {
  const theme = useUIStore((s) => s.theme);
  const editorTheme = useUIStore((s) => s.editorTheme);
  const syncResolved = useUIStore((s) => s._syncResolvedTheme);

  useEffect(() => {
    syncResolved();
  }, [theme, editorTheme, syncResolved]);

  useEffect(() => {
    if (theme !== "system") return;
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    const handler = () => syncResolved();
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, [theme, syncResolved]);

  return <>{children}</>;
}
